import { Language } from './thi-translations';

export function normalizeThiLang(raw: string | null | undefined): Language {
  const c = (raw || 'ar').toLowerCase();
  if (c === 'en' || c === 'he' || c === 'ar') {
    return c;
  }
  return 'ar';
}
